export const DELETE_BUILDING_REQUEST = 'DELETE_BUILDING_REQUEST'
export const DELETE_BUILDING_RESET = 'DELETE_BUILDING_RESET'
export const DELETE_BUILDING_SUCCESS = 'DELETE_BUILDING_SUCCESS'
export const DELETE_BUILDING_ERROR = 'DELETE_BUILDING_ERROR'
